import React from 'react';
import {View} from 'react-native';
import HomeDice from './components/dice/home-dice';
import {
  DigitListItem,
  KeralaListItem,
  MatkaListItem,
  HomeGameFloorItem,
  HomeGameCardItem,
  IHomeSportsCardItem,
} from './home.type';
import HomeDigits from './components/digit/home-digits';
import HomeColor from './components/home-color';
import HomeKerala from './components/kerala/home-kerala';
import HomeMatka from './components/matka/home-matka';
import HomeCar from './components/car/home-car';
import HomeLottery from './components/lottery/home-lottery';
import {sportsIconMap, toSportItem} from '../gr8-sports/converts';
import SportFloor from '../gr8-sports/components/sport-floor';
import globalStore from '@/services/global.state';

export interface HomeTabListContentProps {
  homeGames: HomeGameFloorItem[];
  digitList: DigitListItem[];
  keralaList: KeralaListItem[];
  matkaList: MatkaListItem[];
  onMeasure: (index: number, anchor: number) => void;
}

const HomeTabListContent = ({
  homeGames = [],
  onMeasure = () => {},
  digitList = [],
  keralaList = [],
  matkaList = [],
}: HomeTabListContentProps) => {
  // const dataContent = [
  //   {
  //     name: 'Dice',
  //     content: <HomeDice diceList={diceList.slice(0, 2)} />,
  //   },
  //   {
  //     name: 'Color',
  //     content: <HomeColor />,
  //   },
  //   {
  //     name: '3Digits',
  //     content: <HomeDigits digitList={digitList} />,
  //   },
  //   {
  //     name: 'Car',
  //     content: <HomeCar carList={carList} />,
  //   },
  //   {
  //     name: 'Kerala',
  //     content: <HomeKerala keralaList={keralaList} />,
  //   },
  //   {
  //     name: 'Matka',
  //     content: <HomeMatka matkaList={matkaList} />,
  //   },
  // ];
  const handleLink = (floor: HomeGameFloorItem) => {
    if (floor.uniqueKey === 'HotMatches') {
      return globalStore.openSports.next('/cricket');
    }
    if (floor.uniqueKey === 'TableTennis') {
      globalStore.openSports.next('/table-tennis/live');
      return;
    }
    if (floor.uniqueKey === 'CyberSport') {
      globalStore.openSports.next('/e-sports/live');
      return;
    }
    globalStore.openSports.next(`/${floor.uniqueKey.toLowerCase()}/live`);
  };
  const renderSports = (floor: HomeGameFloorItem) => {
    if (!floor.tagName || !floor.tagName.endsWith('_sport')) {
      return null;
    }
    if (!floor.gamesList?.length) {
      return null;
    }
    try {
      const gamesList = floor.gamesList as IHomeSportsCardItem[];
      const sport = floor.tagName?.split('_')[0];
      const isSport =
        gamesList[0].grSportName.toLowerCase() === sport.toLowerCase();
      const isHotOrPremierLeague =
        floor.uniqueKey === 'HotMatches' ||
        floor.uniqueKey === 'PremierLeague' ||
        floor.uniqueKey === 'Premier League';
      return (
        <SportFloor
          title={floor.name}
          sportsList={gamesList.map(game => toSportItem(game))}
          hasLink={isSport || isHotOrPremierLeague}
          hasLiveIcon={isSport}
          onLinkClick={() => handleLink(floor)}
          isSport={isSport}
          defaultSportIcon={
            floor.categoryPic ||
            sportsIconMap[sport as keyof typeof sportsIconMap] ||
            undefined
          }
        />
      );
    } catch (error) {
      // 如果报错，则不渲染
      console.log('error', error);
      return null;
    }
  };
  return (
    <View>
      {homeGames.map((_, i) => (
        <View
          key={i}
          onLayout={e => {
            onMeasure(i, e.nativeEvent.layout.height);
          }}>
          {renderSports(_)}
          {_.uniqueKey === 'dice' && (
            <HomeDice diceList={_.gamesList as HomeGameCardItem[]} />
          )}
          {_.uniqueKey === 'color' && <HomeColor />}
          {_.uniqueKey === '3Digits' && <HomeDigits digitList={digitList} />}
          {_.uniqueKey === 'quickRace' && (
            <HomeCar carList={_.gamesList as HomeGameCardItem[]} />
          )}
          {_.uniqueKey === 'kerala' && <HomeKerala keralaList={keralaList} />}
          {_.uniqueKey === 'matka' && <HomeMatka matkaList={matkaList} />}
          {_.uniqueKey === 'indianLottery' && (
            <HomeLottery
              lotteryList={_.gamesList as HomeGameCardItem[]}
              serverTime={_.currentTimestamp}
            />
          )}
        </View>
      ))}
    </View>
  );
};

export default HomeTabListContent;
